export default __webpack_public_path__ + "static/media/barcodeScan.79f774fb.mp3";